import { render, staticRenderFns } from "./SDate.vue?vue&type=template&id=fd22e7ea"
import script from "./SDate.vue?vue&type=script&lang=js"
export * from "./SDate.vue?vue&type=script&lang=js"
import style0 from "./SDate.vue?vue&type=style&index=0&id=fd22e7ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports